import ImageGalleryBlock from './image-gallery-block';

export default ImageGalleryBlock;
